import { useQuery } from "@tanstack/react-query";
import { RequestOrderFormSelectedOptions } from "hooks/api/requestOrder";
import useSelectedContractDocEntry from "hooks/useSelectedContractDocEntry";
import {
  getContractOrderRequestQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getContractOrderRequestQueryOptions";

const useGetContractOrderRequestModesOfTransportation = ({
  shipTo,
  shipFrom,
  salesTerms,
  mode,
}: RequestOrderFormSelectedOptions) => {
  const selectedContractDocEntry = useSelectedContractDocEntry();
  return useQuery({
    ...getContractOrderRequestQueryOptions(selectedContractDocEntry, {
      warehouseCode: shipFrom?.value,
      salesTermsCode: salesTerms?.value,
      shipToCode: shipTo?.value,
    }),
    enabled: !!selectedContractDocEntry && !mode,
    keepPreviousData: !!mode,
    select: ({ data }) =>
      data?.ModeOfTransportations?.map(mapDimCodeNameToSelectOption),
  });
};

export default useGetContractOrderRequestModesOfTransportation;
